import React from 'react';
import {
  getWhiteLabelCompanyName,
  getWhiteLabelDescription,
  getWhiteLabelLogoWithNameUrl,
} from 'utils/whiteLabelConfig';

const WhiteLabelContent: React.FC = () => {
  const companyName = getWhiteLabelCompanyName();
  const description = getWhiteLabelDescription();
  const logoUrl = getWhiteLabelLogoWithNameUrl();

  return (
    <div className="hidden flex-col items-start justify-start lg:flex">
      <img src={logoUrl} alt={`${companyName} Logo`} className="mb-6 h-9 w-auto" />
      <h1 className="text-xl font-semibold text-neutral-800" data-testid="white-label-page-title">
        Welcome to {companyName} Payroll
      </h1>
      <div className="mt-6 text-sm font-medium text-neutral-500">
        {description}
        <br />
        <br />
        Pay anyone, anywhere. Industry-leading exchange rates. Available in 135+ countries.
        <br />
        <br />
        Let's Begin.
        <br />
        <br />
        <div className="flex items-center text-xs font-normal text-neutral-400">
          <span className="mr-2">Powered by</span>
          <img src="/logo/thera-logo-with-name.svg" alt="Thera" className="h-4 w-auto" />
        </div>
      </div>
    </div>
  );
};

export default WhiteLabelContent;
